import createHttp from './request'

/**
 * 登录后校验是否需要签署协议
 */
export function checkAgreementSign() {
  const http = createHttp()
  return http({
    url: '/admin/upms/student/agreement/checkSign',
    method: 'post',
    requireAuth: true,
  })
}

/**
 * 提交协议手签
 */
export function submitAgreementSign(data) {
  const http = createHttp()
  return http({
    url: '/admin/upms/student/agreement/sign',
    method: 'post',
    requireAuth: true,
    data: {
      studentAgreementSignDto: data,
    },
  })
}

/**
 * PC 端创建扫码活体票据
 */
export function createLivenessQr(templateId) {
  const http = createHttp()
  return http({
    url: '/admin/upms/student/agreement/liveness/createQr',
    method: 'post',
    requireAuth: true,
    data: { templateId },
  })
}

/**
 * PC 端轮询扫码活体状态
 */
export function getLivenessTicketStatus(ticketId) {
  const http = createHttp()
  return http({
    url: '/admin/upms/student/agreement/liveness/ticketStatus',
    method: 'get',
    requireAuth: true,
    params: { ticketId },
  })
}

/**
 * 扫码页读取票据信息（免登录）
 */
export function getLivenessTicketInfo(ticketId) {
  const http = createHttp()
  return http({
    url: '/admin/upms/student/agreement/liveness/ticketInfo',
    method: 'get',
    requireAuth: false,
    params: { ticketId },
  })
}

/**
 * 发起协议活体（Glow / VIAPI）
 */
export function initAgreementLiveness(data) {
  const http = createHttp()
  const needAuth = !data?.ticketId
  return http({
    url: '/admin/upms/student/agreement/liveness/init',
    method: 'post',
    requireAuth: needAuth,
    data: {
      agreementLivenessInitDto: data,
    },
  })
}

/**
 * 查询实人认证结果
 */
export function queryAgreementLiveness(certifyId) {
  const http = createHttp()
  return http({
    url: '/admin/upms/student/agreement/liveness/query',
    method: 'post',
    requireAuth: false,
    data: {
      agreementLivenessQueryDto: { certifyId },
    },
  })
}

/**
 * VIAPI 自拍核验（扫码页免登录，凭 ticketId）
 */
export function viapiVerifyAgreementLiveness(data) {
  const http = createHttp()
  const needAuth = !data?.ticketId
  return http({
    url: '/admin/upms/student/agreement/liveness/viapi/verify',
    method: 'post',
    requireAuth: needAuth,
    data: {
      agreementLivenessViapiDto: data,
    },
  })
}
